export const initialState = {
    servicepoint_type_id: null,
    name: {
        az: '',
        en: '',
        ru: ''
    },
    address: {
        az: '',
        en: '',
        ru: ''
    },
    image: '',
    area_id: '',
    relevant_person: '',
    opening_time: '',
    closing_time: '',
    phone: '',
    latitude: null,
    longitude: null,
    client_ids: null
};
